// Chiffrage proposé (CCTP / DPGF) : choix initial d'un élément, sans JSX (testé par tests/unit/ma-gamme-proposee.test.ts).
// « On préconise, on propose » (décision du 31/10/2026) : le choix initial est l'ouvrage type reconnu par le serveur, ou rien ; un
// produit Ma gamme compatible est PROPOSÉ dans la liste (« Proposé (Ma gamme) », en tête), jamais sélectionné d'office.
export const PREFIXE_GAMME = 'g:';
/** Choix : `ouvrageId` porte un ouvrage type, ou « g:<produit> » pour un produit « Ma gamme » (choisi par l'utilisateur seulement). */
export interface Choix { coche: boolean; ouvrageId: string; quantite: string; unite: string }
/** Décimal serveur → saisie française (« 12.5 » → « 12,5 »). */
export const versSaisie = (v: string | null) => (v === null ? '' : String(Number(v)).replace('.', ','));

export function choixInitial(i: { coche: boolean; ouvrage: { id: string } | null; quantite: string | null; unite: string | null }): Choix {
  const ouvrageId = i.ouvrage?.id ?? '';
  // Garde-fou : un identifiant « g:… » venu du serveur n'est jamais repris comme choix initial.
  return { coche: i.coche, ouvrageId: ouvrageId.startsWith(PREFIXE_GAMME) ? '' : ouvrageId, quantite: versSaisie(i.quantite), unite: i.unite ?? '' };
}
